import React from 'react';

const FullStackEngineer = () => {
  const styles = {
    badgeRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 10,
      alignItems: 'center',
      marginTop: 6,
      marginBottom: 16,
      padding: '10px 12px',
      borderRadius: 12,
      border: '1px solid #e5e7eb',
      background: '#f9fafb',
      fontSize: 13.5,
      color: '#111827',
      lineHeight: 1.4,
    },
    badgeDot: { color: '#9ca3af' },

    p: {
      fontSize: 14.5,
      lineHeight: 1.75,
      margin: '10px 0',
      color: '#111827',
    },

    h2: {
      fontSize: 18,
      margin: '26px 0 10px',
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    h3: {
      margin: '18px 0 8px',
      fontSize: 15,
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    ul: {
      margin: '10px 0 10px 22px',
      fontSize: 14.5,
      lineHeight: 1.75,
      color: '#111827',
    },

    highlightBox: {
      marginTop: 18,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #dbeafe',
      background: '#eff6ff',
      lineHeight: 1.6,
    },
    highlightText: {
      margin: 0,
      fontSize: 14.5,
      color: '#111827',
    },

    callout: {
      marginTop: 14,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #fde68a',
      background: '#fffbeb',
      lineHeight: 1.6,
    },
    calloutTitle: {
      margin: 0,
      fontSize: 14,
      fontWeight: 900,
      color: '#111827',
      letterSpacing: '-0.01em',
    },
    calloutText: {
      margin: '6px 0 0',
      fontSize: 14.5,
      color: '#111827',
    },
  };

  return (
    <div>
      <h2 style={styles.h2}>Software Engineer – Full Stack (React | Node.js | MongoDB)</h2>

      <div style={styles.badgeRow}>
        <span>
          📍 <strong>India</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🌐 <strong>Startup Environment</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🌍 <strong>Remote</strong>
        </span>
      </div>

      <p style={styles.p}>
        We’re looking for a Full Stack Software Engineer who enjoys working across the stack and
        solving real performance and scalability challenges.
      </p>

      <p style={styles.p}>
        You’ll be involved in designing, building, and optimizing web applications, APIs, real-time
        systems, and AI-powered features, working closely with the founding and engineering teams.
      </p>

      <h3 style={styles.h3}>Key Responsibilities</h3>
      <ul style={styles.ul}>
        <li>Build and maintain web applications using React.js and JavaScript</li>
        <li>Develop scalable backend services with Node.js and Express</li>
        <li>Design and optimize MongoDB schemas, indexing, and queries</li>
        <li>Implement real-time features using Socket.IO</li>
        <li>Integrate AI APIs (e.g., ChatGPT and other third-party AI services)</li>
        <li>Improve application performance, scalability, and reliability</li>
        <li>Handle deployments on Heroku, AWS, and Netlify</li>
        <li>
          Monitor, debug, and tune applications (memory usage, garbage collection, performance)
        </li>
        <li>Collaborate closely with product and engineering teams</li>
      </ul>

      <h3 style={styles.h3}>Required Skills</h3>
      <ul style={styles.ul}>
        <li>Strong experience with React.js (modern hooks &amp; patterns)</li>
        <li>JavaScript (ES6+)</li>
        <li>Node.js &amp; Express</li>
        <li>MongoDB (query optimization, indexing)</li>
        <li>Socket.IO / real-time systems</li>
        <li>REST API design and integration</li>
        <li>Experience integrating AI APIs (ChatGPT, LLM-based services, or similar)</li>
        <li>Deployment experience with Heroku, AWS, and Netlify</li>
        <li>Performance tuning, memory management, and garbage collection basics</li>
        <li>Debugging and production troubleshooting</li>
      </ul>

      <h3 style={styles.h3}>Nice to Have</h3>
      <ul style={styles.ul}>
        <li>Experience with Redis, queues, or caching</li>
        <li>CI/CD pipelines</li>
        <li>AI prompt design or optimization</li>
        <li>System design for scale</li>
        <li>Startup or high-growth environment experience</li>
      </ul>

      <div style={styles.callout}>
        <p style={styles.calloutTitle}>What We’re Looking For</p>
        <p style={styles.calloutText}>
          Strong problem-solving skills • Ownership mindset • Clear communication • Curiosity and
          willingness to learn new technologies
        </p>
      </div>

      <div style={styles.highlightBox}>
        <p style={styles.highlightText}>
          <strong>Why Join Us:</strong> Direct work with founders and senior engineers • High
          ownership and real impact • Opportunity to work on AI-driven features • Grow with the
          company as we scale
        </p>
      </div>
      {/* ✅ APPLY BY EMAIL — Full Stack Engineer */}
      <div
        style={{
          marginTop: 16,
          padding: 16,
          borderRadius: 14,
          border: '2px solid #FF6138',
          background: '#fff2ecff',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ minWidth: 220 }}>
            <div
              style={{
                fontSize: 14.5,
                fontWeight: 900,
                color: '#111827',
                letterSpacing: '-0.01em',
              }}
            >
              Apply by Email
            </div>
            <div style={{ marginTop: 6, fontSize: 13.5, color: '#374151', lineHeight: 1.6 }}>
              Email your <strong>CV/Resume</strong> and mention the <strong>Job Title</strong> in
              the subject line.
            </div>
          </div>

          <a
            href='mailto:jobs@singlecombo.com?subject=Application%20-%20Software%20Engineer%20Full%20Stack%20(React%20Node%20MongoDB)'
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 12px',
              borderRadius: 12,
              border: '1px solid #dbeafe',
              background: '#eff6ff',
              color: '#111827',
              textDecoration: 'none',
              fontSize: 13.5,
              fontWeight: 800,
              whiteSpace: 'nowrap',
            }}
            aria-label='Email jobs@singlecombo.com'
          >
            ✉️ jobs@singlecombo.com
          </a>
        </div>

        <div
          style={{
            marginTop: 12,
            paddingTop: 12,
            borderTop: '1px solid #e5e7eb',
            display: 'grid',
            gap: 8,
          }}
        >
          <div style={{ fontSize: 13, color: '#6b7280' }}>
            <strong style={{ color: '#111827' }}>Subject:</strong> Application - Software Engineer
            Full Stack (React | Node.js | MongoDB)
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>
            <strong style={{ color: '#111827' }}>Include:</strong> Name • Location •
            Portfolio/GitHub • Relevant projects • Experience (React/Node/Mongo) • Availability
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullStackEngineer;
